import { Redirect, Route } from "react-router-dom";
import React, { ReactElement } from "react";
import { RouteComponentProps } from "react-router";
import router from "@/router/index";
// 获取语言环境
export const getLang = () => {
  const pathSnippets = location.pathname.split("/").filter((i: string) => i);
  const urlLang = pathSnippets[0] === "en" ? "en" : "zh";
  if (localStorage.lang) return localStorage.lang;
  return urlLang;
};
// 页面统一渲染入口
export const RouterTemplate = ({ ...parentProps }) => {
  const { route, component } = parentProps;
  return (
    <Route
      key={route?.match.path}
      path={route?.match.path}
      exact={route?.match.isExact}
      render={(props) => {
        if (component?.props?.render) {
          return component.props.render({ ...props, ...parentProps });
        } else {
          return React.createElement(component.props.component, { ...props, ...parentProps });
        }
      }}
    />
  );
};
// 判断-修改-指定路由
export const RouterSwitch = (routerProps: RouteComponentProps) => {
  const { location } = routerProps;
  const { pathname } = location;
  const pathSnippets = pathname.split("/").filter((i: string) => i);
  let resultSnippetsStr = pathSnippets.includes("en")
    ? "/" + pathSnippets.slice(1).join("/")
    : pathname;
  const resultSnippets = resultSnippetsStr.split("/").filter((i: string) => i);
  const lastStr = resultSnippets[resultSnippets.length - 1];
  const lastStrNum = Number(lastStr);
  if (!isNaN(lastStrNum) && lastStrNum !== 404 && resultSnippets.length > 1) {
    resultSnippets.pop();
  }
  resultSnippetsStr = "/" + resultSnippets.join("/");
  const params: { [key: string]: string } = {};
  const currentRoute = router.props.children.find((route: ReactElement) => {
    if (!route) return false;
    const {
      props: { path },
      key,
    } = route;
    if ((key ?? path) === resultSnippetsStr) {
      const paramKey = path.match(/:(\w+)/)?.[1];
      params[paramKey] = lastStr;
      return route;
    }
  });
  if (!currentRoute) {
    return <Redirect to="/404" />;
  }
  routerProps.match.params = {
    ...routerProps.match.params,
    ...params,
  };
  return <RouterTemplate {...routerProps} component={currentRoute} lang={getLang()} />;
};
